import React from 'react';

const Profile = ({ menuOpen, isDesktop }) => {
  const username = "JohnDoe"; // Hardcoded username
  const userImage = "https://i.seadn.io/gae/JJZO915-uQDdN-60xsgWpq83I4nc6Eh0xPGShLqi-tyMiUsT1O_MyPU-aTBB8vSOHQ_G8S2UingJDWi7iXd1ivCEX6XqZosFHbIc_A?auto=format&dpr=1&w=1000"; // Hardcoded user image URL
  const posts = [
    { id: 1, content: "This is my first post!" },
    { id: 2, content: "Loving this new social media app!" },
    { id: 3, content: "Just had a great day!" },
  ]; // Hardcoded posts

  return (
    <div style={{ width: '100vw', height: '100vh', padding: "20px", backgroundColor: "var(--background-color)", color: "var(--primary-color)", fontFamily: "'Oswald', sans-serif", marginLeft: menuOpen && isDesktop ? "270px" : "0" }}>
      <h1>Profile</h1>
      <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
        <img src={userImage} alt="User" style={{ width: "100px", height: "100px", borderRadius: "50%", marginRight: "20px", boxShadow: "0 0 10px var(--secondary-color)" }} />
        <h2 style={{ color: "var(--primary-color)", fontFamily: "'PressStart2P', sans-serif" }}>{username}</h2>
      </div>
      <hr style={{ border: "1px solid var(--border-color)", marginBottom: "20px", marginRight: "40px" }} />
      <div>
        <h3>Posts</h3>
        {posts.map(post => (
          <div key={post.id} style={{ marginBottom: "10px", padding: "10px", border: "1px solid var(--border-color)", borderRadius: "5px", color: "var(--text-color)", boxShadow: "0 0 10px var(--border-color)", marginRight: "40px" }}>
            {post.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;